const addCSSClass = ( id: string, classNameText: string | Node, isPrepend: boolean=false ): void => {
    
    const old: HTMLElement | null  = document.getElementById( id )
    if( old)  old.remove();
    const el = document.createElement("style") 
    el.type = "text/css"  
    el.id = id
    el.append(classNameText)
    if(isPrepend) {
        document.getElementsByTagName("head")[0].prepend(el)
    }
    else {
        document.getElementsByTagName("head")[0].appendChild(el)
    }
    
}
export default  addCSSClass

